import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ProgramDropdown, UserDropdown, TimesheetTaskDropdown } from "CommonDropdowns";
import moment from 'moment-timezone';

const Filter = ({ onFilter, extraFiltersState, setExtraFiltersState }) => {
    const [programValue, setProgramValue] = useState(null);
    const [userValue, setUserValue] = useState(null);
    const [taskValue, setTaskValue] = useState(null);

    const handleSearch = () => {
        onFilter();
    };

    const handleInputChange = (name, value) => {
        setExtraFiltersState({
            ...extraFiltersState,
            values: {
                ...extraFiltersState.values,
                [name]: value,
            },
        });
    };

    const handleDateChange = (date) => {
        if(!date){
            setProgramValue(null);
            setUserValue(null);
            setTaskValue(null);
            setExtraFiltersState({
                ...extraFiltersState,
                values: {
                    ...extraFiltersState.values,
                    year: '',
                    month: '',
                    program_ids: [],
                    user_ids: [],
                    task_ids: [],
                    selectedDate: null,
                    month_year: ''
                },
            });
        }else{
            let monthYear = moment(date).format('YYYY-MM');
            setExtraFiltersState({
                ...extraFiltersState,
                values: {
                    ...extraFiltersState.values,
                    year: date.getFullYear(),
                    month: date.getMonth() + 1,
                    month_year: monthYear,
                    selectedDate: date
                },
            });
        }
    };

    const handleProgramChange = (selected) => {
        setProgramValue(selected);
        setTaskValue(null);
        const programIds = selected ? selected.map(p => p.value) : [];
        setExtraFiltersState({
            ...extraFiltersState,
            values: {
                ...extraFiltersState.values,
                program_ids: programIds,
                task_ids: [],
            },
        });
    };

    const handleUserChange = (selected) => {
        setUserValue(selected);
        setTaskValue(null);
        let userIds = [];
        if (selected) {
            userIds = selected.map(u => u.value).filter(val => val !== 'all');
        }
        setExtraFiltersState({
            ...extraFiltersState,
            values: {
                ...extraFiltersState.values,
                user_ids: userIds,
                task_ids: [],
            },
        });
    };

    const handleTaskChange = (selected) => {
        setTaskValue(selected);
        const taskIds = selected ? selected.map(t => t.value).filter(val => val !== 'all') : [];
        handleInputChange("task_ids", taskIds);
    };

    return (
        <div className="filters-flex">
            <Form>
                <Row className="align-items-end g-3">
                    <Col md={2} sm={12}>
                        <Form.Group className="mb-3">
                            <Form.Label className="label-input">Month</Form.Label>
                            <DatePicker
                                selected={extraFiltersState.values.selectedDate}
                                onChange={handleDateChange}
                                dateFormat="yyyy-MM"
                                showMonthYearPicker
                                className="input-field form-control"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3} sm={12}>
                        <Form.Group className="mb-3">
                            <ProgramDropdown
                                programValue={programValue}
                                setProgramValue={setProgramValue}
                                isMulti
                                selectedId={extraFiltersState.values.program_ids}
                                programOnChange={handleProgramChange}
                                loadManagerPrograms={true}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3} sm={12}>
                        <Form.Group className="mb-3">
                            <UserDropdown
                                userValue={userValue}
                                setUserValue={setUserValue}
                                isMulti
                                selectedId={extraFiltersState.values.user_ids}
                                userOnChange={handleUserChange}
                                loadManagerProgramUsers={true}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3} sm={12}>
                        <Form.Group className="mb-3">
                            <TimesheetTaskDropdown
                                taskValue={taskValue}
                                setTaskValue={setTaskValue}
                                isMulti
                                selectedId={extraFiltersState.values.task_ids}
                                taskOnChange={handleTaskChange}
                                programId={extraFiltersState.values.program_ids && extraFiltersState.values.program_ids.length > 0 ? extraFiltersState.values.program_ids[0] : null}
                                user_ids={extraFiltersState.values.user_ids && extraFiltersState.values.user_ids.length > 0 ? extraFiltersState.values.user_ids : null}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={1} sm={12} className="d-flex gap-2 mt-3 mt-md-0">
                        <button
                            type="button"
                            onClick={handleSearch}
                            className="add-new-btn w-100 mb-3"
                        >
                            <img src="/assets/images/search-white.svg" alt="" className="me-2" /> Search
                        </button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default Filter;